import { Typography } from '@mui/material';
import { usePartnerReferralDetailsStyles } from '../styles';

export type NoteDetailsProps = {
  content: string;
};

export const NoteDetails: React.VFC<NoteDetailsProps> = ({ content }) => {
  const { classes } = usePartnerReferralDetailsStyles();

  if (content) {
    return (
      <>
        {content.split(/(\r\n|\r|\n)+/g).map((paragraph, index) => (
          <Typography variant="body1" key={index} data-testid="referral-note-content">
            {paragraph}
          </Typography>
        ))}
      </>
    );
  } else {
    return (
      <Typography variant="body1" className={classes.noNote} data-testid="referral-no-note">
        No note
      </Typography>
    );
  }
};
